import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { weatherIconMap } from './WeatherIconMap';
import { WidgetCard } from '../../../components/common';
import { WeatherIconName } from '../../../types/Weather';

export type WeatherUVIndexCardProps = {
  value: number;
  level: string;
  message: string;
  iconName: WeatherIconName;
};

export const WeatherUVIndexCard = ({
  value,
  level,
  message,
  iconName,
}: WeatherUVIndexCardProps) => {
  const { t } = useTranslation();
  const Icon = weatherIconMap[iconName];
  const iconSize = 120;

  return (
    <WidgetCard
      title={t('weather.uvIndex')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack alignItems="center" gap="$3.5" justifyContent="space-between" height="100%" flex={1}>
        <YStack paddingVertical="$5" gap="10px" alignItems="center">
          <YStack width={iconSize} height={iconSize}>
            {Icon ? Icon(tokens.color.textLight, iconSize, true, iconSize * 1.75) : null}
          </YStack>
          <Text fontSize="$12" fontWeight="900" color="$textLight">
            {value} - {level}
          </Text>
        </YStack>
        <Text fontSize="$9.5" color="$textLight">
          {message}
        </Text>
      </YStack>
    </WidgetCard>
  );
};
